import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/product_page_suggestions.jinja";
import { addVisibilityWatcher } from "web/script/modules/visibility-watcher";
import url from "web/script/utils/url";

import "web/script/components/tracked-link";

export default baustein.register("product-page-suggestions", {
    template,

    defaultOptions: {
        slug: null,
        uid: null,
    },

    init() {
        this._removeVisibilityWatchers = [];
    },

    getInitialRenderContext() {
        return {
            product_page_suggestions: {
                is_loading: true,
                product_slug: null,
                product_uid: null,
                reason: "",
                suggested_card_rows: [],
            },
        };
    },

    onInsert() {
        const { isLoading, slug, uid } = this.options;

        // If it's not loading, we don't fetch / render anything
        if (!isLoading) {
            this._handleCardData();
            return;
        }

        rothko.fetch("modules/product_page_suggestions", { slug, uid }).then((data) => {
            if (!data.cards || !data.cards.length) {
                this.destroy();
                return;
            }

            this.setRenderContext({
                product_page_suggestions: data,
            });

            this._handleCardData();
        });
    },

    onRemove() {
        this._removeVisibilityWatchers.forEach((removeVisibilityWatcher) => {
            removeVisibilityWatcher();
        });
    },

    _handleCardData() {
        // Update URLs with reason query parameter
        Array.from(this.el.querySelectorAll("[data-reason]")).forEach((suggestedCard) => {
            const parsed = url.parse(suggestedCard.href);
            parsed.searchParams.set("reason", suggestedCard.dataset.reason);
            suggestedCard.href = url.unparse(parsed);
        });

        // Send events when a user views the suggested cards
        Array.from(this.el.querySelectorAll("[data-seen-event-label]")).forEach((suggestedCard) => {
            const removeVisibilityWatcher = addVisibilityWatcher(
                suggestedCard,
                (visible) => {
                    if (visible) {
                        const eventLabel = suggestedCard.dataset.seenEventLabel;
                        analytics.event(
                            "in_viewport",
                            "product_page_suggestions",
                            `seen_${eventLabel}`,
                            true
                        );
                        removeVisibilityWatcher();
                    }
                },
                { rootMargin: "0px" }
            );

            this._removeVisibilityWatchers.push(removeVisibilityWatcher);
        });
    },
});
